import { GET_ROLE_LIST_URL, GET_BU_LIST_URL, GET_GBP_LIST_URL } from '../../const/APIUrl.js';
import { fetchAPI } from '../../api/GenericFetch.js';
import { Suspense } from 'react';
import { useLoaderData, Await } from 'react-router-dom';
import MstUserComponent from '../Components/Master/User.tsx';
import { getPageFunction, pageEnum } from '../../security/LoginDetail.js';

export default function MstUser(){  
  const pageFunction = getPageFunction({pageId : pageEnum.MstUser});
  const dropDownList = useLoaderData();
    return (        
      <Suspense>
        <Await resolve={dropDownList}>
          {(dropdownList) => <MstUserComponent roleList={dropdownList.roleList} buList={dropdownList.buList} gbpList={dropdownList.gbpList} 
            pageFunction={pageFunction} />}
        </Await>
      </Suspense>
    );
}

export async function loader() {
  const [buList, gbpList, roleList] = await Promise.all([
          fetchAPI({url:GET_BU_LIST_URL}),
          fetchAPI({url:GET_GBP_LIST_URL}),
          fetchAPI({url:GET_ROLE_LIST_URL})          
      ]);
  return {buList, gbpList, roleList};
}